<template>
  <div class="modal-chat" v-show="modalChat">
    <div class="modal-chat-content">
      <div class="btn-close">
        <button class="btn" @click="$store.state.modalChat = false" title="Fechar Chat"><i class="fa fa-times"></i></button>
      </div>
      <div class="box-iframe" v-if="!load && src">
        <iframe id="myIframe" :src="src" frameborder="0"></iframe>
      </div>
      <div v-else-if="empresa.chat_lecard !== '1'" class="d-flex justify-content-center align-items-center" style="height: calc(100vh - 65px)">
        <div class="container text-center">
          <img src="../../assets/bg-chat.png" alt="Chats" class="img-fluid" style="max-width: 212px">
          <h5 class="font-weight-bold mt-3 text-dark">Chat de Pedidos</h5>
          <div class="mx-auto" style="max-width: 600px">
            <p class="mb-2">
              Quando seu cliente realiza um pedido e, caso precise fazer alguma alteração após a aprovação, ele enviará uma mensagem diretamente pelo app. Você receberá um alerta sonoro aqui no Gestor de Pedidos, possibilitando que converse diretamente com ele.
            </p>
            <p>Para ativar o módulo de chat acesse o menu <b>"Configs"</b>.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Modal from "./ModalGestor";
  import Loading from "@/components/commons/Loading";

  export default {
    name: "ModalChat",
    components: {Loading, Modal},
    props: ['pesquisa','printServer'],

    data() {
      return {
        load: true,
        src: null,
        token: localStorage.getItem('key')
      }
    },

    mounted() {
      const url = this.empresa.chat_lecard === '1' ? process.env.VUE_APP_CHAT : null;

      if (url && this.token) {
        this.src = `${url}?auth=${this.token}`;

        setTimeout(() => {
          this.load = false;
        }, 1500);
      }
    },

    computed: {
      modalChat() {
        return this.$store.state.modalChat;
      },

      empresa() {
        return this.$store.state.dataUser;
      }
    }
  }
</script>

<style scoped>
.modal-chat {
  display: block; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 9990; /* Sit on top */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: hidden; /* Enable scroll if needed */
  background-color: rgb(0,0,0); /* Fallback color */
  background-color: rgba(0,0,0,0.4); /* Black w/ opacity */
}

/* Modal Content/Box */
.modal-chat-content {
  background-color: #fefefe;
  border-radius: 6px;
  width: 90%;
  height: calc(100vh - 58px);
  max-width: 1200px;
  margin: 30px auto 0;
  position: relative;
  overflow: hidden;
}

.btn-close {
  position: absolute;
  top: 0;
  right: 0px;
  font-size: 18px;
  background-color: #F0F2F5;
}

.btn-close .btn {
  width: 56px;
  height: 56px;
}

.btn-chat {
  bottom: 90px;
  right: 15px;
  position: fixed;
  z-index: 9999999;
}

.btn-chat .btn {
  border-radius: 50%;
  width: 60px;
  height: 60px;
}

.btn-chat img {
  width: 100%;
  object-fit: contain;
}

@media (max-width: 767px) {
  .modal-chat-content {
    margin: 10px auto;
    width: 95%;
    max-width: none;
  }
}
</style>